<template>
  <div class="viewport viewport-with-top-nav viewport-compact align-items-center justify-content-center">
    <spinner v-if="loading"></spinner>
    <template v-else>
      <top-nav></top-nav>
      <otp @otp-success="onOtpSuccess" :pin="pin" v-if="pin"></otp>
    </template>
  </div>
</template>

<script>
import Otp from '@shared/components/Otp'
import LoanApplicationMixin from '@shared/mixins/LoanApplicationMixin'
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'
import UserMixin from '@shared/mixins/UserMixin'
import pushNotificationSettings from '@shared/push-notification-settings'
import settings from '@shared/settings'

export default {
    components: { Otp, TopNav },
    mixins: [LoanApplicationMixin, UserMixin],
    data() {
      const application = store.getApplication()
      return {
        loading: true,
        pin: application && application.borrower && application.borrower.pin,
        phone: application && application.borrower && application.borrower.phone
      }
    },
    async mounted() {
      if (!this.pin) {
        await this.$router.replace({ name: 'home' })
      } else {
        this.signUp()
      }
    },
    methods: {
      signUp() {
        const payload = {
          pin: this.pin,
          phone: this.phone,
          deviceToken: pushNotificationSettings.deviceToken(),
          devicePlatform: settings.devicePlatform()
        }
        this.$http.post('/api/authentication/sign-up', payload)
                .then(() => {
                  this.loading = false
                })
                .catch((err) => {
                  if (err.response.status === 400) {
                    this.$errorToast(this.$t('errors.technical.title'), this.$t('errors.technical.content'))
                  }
                  this.$router.back()
                })
      },
      onOtpSuccess() {
        this.loading = true
        this.submitAsNewCustomer()
            .then(() => this.getAndStoreCustomerProfile(this.pin))
            .then(() => this.redirectToThankYouPage())
      },
      redirectToThankYouPage() {
        this.$router.replace({ name: 'no-back', params: { page: 'thank-you-for-loan-application' } })
        store.promoteBiometricLogin(this.pin)
      }
    }
  }
</script>
